module.exports = __webpack_public_path__ + "static/img/industrial.0ee7f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/industrial.png
// module id = TyKf
// module chunks = 11